import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { IconButton } from "@fluentui/react/lib/Button";
import { Stack } from "@fluentui/react/lib/Stack";
import { Text } from "@fluentui/react/lib/Text";

import { projectsFilterExpressionAdd } from "Store/Actions";
import { escapeAllQuoteTypes, isString } from "Utils/String";
import { IFilterToolTipContentProps } from "./IFilterToolTipContentProps";

export function FilterToolTipContent(props: IFilterToolTipContentProps): JSX.Element {
  const { fieldName, value, rawValue } = props;
  const dispatch = useDispatch();

  const onClick = useCallback(() => {
    let expressionValue = rawValue ?? value;
    if (isString(expressionValue)) {
      expressionValue = escapeAllQuoteTypes(expressionValue);
    }
    dispatch(projectsFilterExpressionAdd(`${fieldName}:"${expressionValue}"`));
  }, [dispatch, fieldName, rawValue, value]);

  return (
    <Stack horizontal>
      <Stack.Item align="center">
        <Text>{value}</Text>
      </Stack.Item>
      <Stack.Item>
        <IconButton onClick={onClick} iconProps={{ iconName: `Filter` }} />
      </Stack.Item>
    </Stack>
  );
}
